export default __webpack_public_path__ + "static/media/platform.ca4f6e71.jpg";